import styled from "styled-components";
import { calculateResponsiveSize } from "helpers/calculateResponsiveSize";
import { mediaMax } from "helpers/mediaQueries";
import CloseIcon from "icons/close.svg";
import WhiteDollarIcon from "images/dollar_white.svg";

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: auto;
  z-index: 100;
  transition: margin-top 1s;
  overflow: hidden;
  background: #292929e5;
  justify-content: center;

  ${mediaMax("mobile")} {
    gap: 16px;
    height: auto;
    padding: 2px 16px 2px 16px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SpecialContent = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px ${calculateResponsiveSize(25)};
  gap: ${calculateResponsiveSize(30)};
  color: white;

  ${mediaMax("mobile")} {
    gap: 16px;
    flex-direction: column;
    align-items: flex-start;
    padding-top:45px;
  }
`;

export const Title = styled.div`
  font-family: "Adobe Caslon Pro Italic";
  font-size: 25px;
  // font-style: italic;
  font-weight: 400;
  // display: flex;
  align-items: baseline;
  line-height: normal;
  letter-spacing: 0em;

  // span {
  //   font-size: clamp(0.75rem, calc(0.654rem + 0.392vw), 1.125rem);
  // }

  ${mediaMax("mobile")} {
    font-size: 20px;
    // line-height: 24px;

    span {
      // font-size: 16px;
    }
  }
`;
export const Text = styled.p`
  color: white;
  font-family: "TT Norms Pro 300";
  font-size: 25px;
  font-style: normal;
  line-height: 100%;
  max-width: ${calculateResponsiveSize(431)};
  ${mediaMax("mobile")} {
    max-width: none;
    width: 100%;
    text-align: center;
  }
`;
export const Buttons = styled.div`
  display: flex;
  align-items: center;
  margin: 0 14px 0px 0px;
  gap: ${calculateResponsiveSize(20)};

  a {
    font-size: 16px;
    padding: 7.5px 14.5px;
    line-height: normal;
    ${mediaMax("mobile")} {
      font-size: 14px;
    }
  }

  ${mediaMax("mobile")} {
    gap: 16px;
  }
`;

export const CloseButton = styled.button`
  -webkit-mask-image: url(${CloseIcon});
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;

  mask-image: url(${CloseIcon});
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  background: white;
  border: none;

  height: ${calculateResponsiveSize(18)};
  width: ${calculateResponsiveSize(18)};
  cursor: pointer;

  position: absolute;
  top: 15px;
  right: 15px;
  ${mediaMax("mobile")} {
    height: 18px;
    width: 18px;
    top: 15px;
    right: 15px;
  }
`;
export const WhiteDollar = styled.div`
  background-image: url(${WhiteDollarIcon});
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  display: inline-block;
`;

export const SpecialDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SpecialTitle = styled.div`
  font-family: "Adobe Caslon Pro Italic";
  font-size: 50px;
  // font-style: italic;
  font-weight: 400;
  color: #000;
  background-color: #ded8d0;
  margin: 7px;
  padding: 7px;
  text-align: center;
  line-height: 1.2;

  ${mediaMax("mobile")} {
    padding: 15px;
    font-size: 40px;
    line-height:1.1;
  }

  & > em {
    display: block;
    font-size: 25px;
  }

    & > span {
    display: block;
    font-size: 25px;
  }
`;

export const SpecialTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ded8d0;
  max-width: 330px;
`;
